/**
 * @generated SignedSource<<7797dbc431bef0af77162ae4f671d45f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableLayout_viewer$data = {
  readonly itemRead: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_item" | "PdpRespUnavailableContextProvider_item" | "PdpSharedOriginalLanguageProvider_item">;
  } | null> | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableLayout_viewer";
};
export type PdpRespUnavailableLayout_viewer$key = {
  readonly " $data"?: PdpRespUnavailableLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableLayout_viewer">;
};

import PdpRespUnavailableLayoutRefetchQuery_graphql from './PdpRespUnavailableLayoutRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayAndBtNone"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBtSsr"
    },
    {
      "kind": "RootArgument",
      "name": "fetchChat"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "maxSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "minSponsoredItemsSteps"
    },
    {
      "kind": "RootArgument",
      "name": "numOfSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": PdpRespUnavailableLayoutRefetchQuery_graphql
    }
  },
  "name": "PdpRespUnavailableLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespUnavailableContainer_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespUnavailableContextProvider_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedOriginalLanguageProvider_item"
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespUnavailableContainer_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0743eab4d1e5c4011b289ba44aeb1472";

export default node;
